import React from "react";
import { compose } from "recompose";
import * as R from "ramda";
import { withTranslation } from "react-i18next";
import { isLoading } from "@worcket/common/hocs";
import copy from "copy-to-clipboard";
import { message, Tooltip } from "antd";
import { useCallback } from "react";
import { Link } from "react-router-dom";

import * as gtag from "../../lib/gtag";
import Button from "../Button";
import { FETCH_OPPORTUNITIES } from "../../store/actions/opportunities";
import { getCompanyURL } from "../../utils/urls";

import styled from "styled-components/macro";

const Container = styled.div`
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  transition: 0.3s;
  border: 1px solid ${({ theme }) => theme["@grey"]};
  background: white;
  display: flex;
  flex-direction: column;

  .subtitle-container {
    padding: 10px 20px;
    background: #f8f9fa;
  }
  &:hover {
    box-shadow: 0px 8px 15px -3px gainsboro;
  }

  .header {
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
    margin: 16px 16px 9px;
    flex-grow: 1;

    a {
      flex-grow: 1;
    }
  }
`;

const Title = styled.h2`
  color: ${({ theme }) => theme["@gray-80"]};
  font-weight: normal;
  font-size: 1rem;
`;

const Subtitle = styled.h4`
  color: ${({ theme }) => theme["@gray-60"]};
  margin: 0;
  font-weight: normal;
  font-size: 12px;
`;

const CopyLinkButton = styled(Button)`
  &,
  &.ant-btn.ant-btn-sm {
    display: flex;
    align-items: center;
    font-size: 9px;
    height: 20px;
    max-width: 80px;
    padding-left: 6.6px;
    padding-right: 4px;
    pointer-events: auto;
    border-color: #d0d9ff !important;

    /* Icon styles */
    .anticon.anticonlink svg {
      fill: ${({ theme }) => theme["@primary"]} !important;
    }
    & > .anticon + span,
    & > span + .anticon {
      margin-left: 4px;
    }
  }
`;

const TeamCard = ({
  companyName,
  name,
  isLoadingOpportunities,
  opportunities,
  id,
  t
}) => {
  const handleCopyTeamLink = useCallback(() => {
    copy(`${getCompanyURL(companyName)}?team=${id}`);
    message.success(t("components:TeamCard.copiedTeamLink"));
  }, [companyName, id, t]);

  const publishedCount = R.length(
    R.filter(R.propEq("status", "published"), opportunities || [])
  );

  return (
    <Container data-test={`team-card-${id}`}>
      <div className="header">
        <Link key={id} to={`/equipos/${id}`}>
          <Title title={name}>{name}</Title>
        </Link>
        <Tooltip
          title={t("components:TeamCard.copyTeamLink")}
          overlayStyle={{
            maxWidth: "none"
          }}
        >
          <CopyLinkButton
            data-test={`copy-team-link-${id}`}
            icon="link"
            onClick={() => {
              handleCopyTeamLink();
              gtag.event({
                category: "Teams",
                action: "Teams.TeamCard.CopyLink",
                label: id
              });
            }}
            size="small"
            shape="round"
          >
            <span style={{ color: "#343A40" }}>...{R.takeLast(8, id)}</span>
          </CopyLinkButton>
        </Tooltip>
      </div>
      <div className="subtitle-container">
        <Link key={id} to={`/equipos/${id}`}>
          <Subtitle data-test="team-opportunities">
            {t("global:opportunities")}:{" "}
            {isLoadingOpportunities ? "..." : R.length(opportunities)}
          </Subtitle>
          <Subtitle data-test="team-published-opportunities">
            {t("opportunities:published")}:{" "}
            {isLoadingOpportunities ? "..." : publishedCount}
          </Subtitle>
        </Link>
      </div>
    </Container>
  );
};

export default compose(
  withTranslation(["global", "opportunities"]),
  isLoading(FETCH_OPPORTUNITIES)
)(TeamCard);
